const eventClickAddCartAccessories = (params, promoCode, couponAmount, category?: string) => {
  if (typeof window !== 'undefined' && params) {
    (window as any)?.dataLayer?.push({
      event: 'addToCart',
      eventCategory: 'ecommerce aksesoris',
      eventLabel: `aksesoris - ${category || 'not available'}`,
      promoCode: promoCode || 'not available',
      couponAmount: 0,
      ecommerce: {
        currencyCode: 'IDR',
        add: {
          products: [params],
        },
      },
    });
  }
};

export default eventClickAddCartAccessories;
